export default __webpack_public_path__ + "static/media/amorim-logo-verde.5a98bce7.svg";